import type { Provider } from '@angular/core';

import { UserManagementStore } from './stores/user-management.store';
import { USER_MANAGEMENT_TRANSLOCO } from './user-management.transloco';

export const USER_MANAGEMENT_ROUTE_PROVIDERS: Provider[] = [USER_MANAGEMENT_TRANSLOCO.provider, UserManagementStore];
